Namespace 'Monitoring.Views.SocialContents'

class Monitoring.Views.SocialContents.SocialContentDetailsTopicsView extends Backbone.View
  template: JST['backbone/templates/monitoring/social_contents_v2/details/topics']

  initialize: ({@topics}) ->
    undefined

  render: ->
    @setElement @template
      topics: @topics.join(', ')
    @
